"use client";

import React from "react";
import { MapPin, CircleCheck, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pins = [{
  name: "Newcastle",
  top: "35%",
  left: "40%"
}, {
  name: "Sunderland",
  top: "45%",
  left: "65%"
}, {
  name: "Durham",
  top: "65%",
  left: "50%"
}];
const councils = ["Newcastle City Council", "Sunderland City Council", "Durham County Council", "Gateshead Council", "North Tyneside Council", "South Tyneside Council"];
export default function ServiceCoverageArea() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: mapRef,
    isVisible: isMapVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: listRef,
    isVisible: isListVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="service-coverage-area" className="bg-background py-16 md:py-24 overflow-hidden relative">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585014/img/grid_pattern_light.png)] opacity-5 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        {}
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-12 md:mb-16 transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-4">
            <MapPin className="size-4" />
            <span>Serving the North East</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-foreground mb-4">
            Local Expertise, <span className="text-primary">Premium Quality</span>
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            From Tyneside to Teesside, Five Star Roofline delivers elite craftsmanship across the region. We are proud to be the trusted choice for homeowners and local authorities alike.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          
          {}
          <div ref={mapRef} className={`lg:col-span-2 relative rounded-2xl bg-secondary overflow-hidden border border-border/10 shadow-2xl min-h-[400px] lg:min-h-[600px] transition-all duration-1000 delay-100 ${isMapVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585014/img/dark_map_northeast.png)] bg-cover bg-center opacity-40 mix-blend-luminosity"></div>
            
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] md:w-3/4 md:h-3/4 bg-primary/15 blur-[80px] md:blur-[120px] rounded-full pointer-events-none"></div>

            {}
            {pins.map((pin, i) => <div key={i} data-index={i} className={`absolute flex flex-col items-center transition-all duration-700 delay-[${300 + i * 200}ms] ${isMapVisible ? "opacity-100 scale-100" : "opacity-0 scale-50"}`} style={{
            top: pin.top,
            left: pin.left
          }}>
                <div className="relative group cursor-pointer">
                  {}
                  <div className="absolute inset-0 bg-primary/40 rounded-full animate-ping"></div>
                  {}
                  <MapPin className="text-primary relative z-10 size-8 md:size-10 drop-shadow-[0_0_10px_rgba(var(--color-primary),0.8)] transition-transform group-hover:scale-110 group-hover:-translate-y-1" />
                </div>
                {}
                <span className="mt-2 px-3 py-1 rounded-full bg-background/90 backdrop-blur-md text-xs md:text-sm font-bold text-foreground border border-border/50 shadow-lg whitespace-nowrap">
                  {pin.name}
                </span>
              </div>)}

            {}
            <div className="absolute inset-0 bg-gradient-to-t from-secondary via-transparent to-transparent opacity-80 pointer-events-none"></div>
            
            {}
            <div className="absolute bottom-6 left-6 flex items-center gap-3 bg-background/10 backdrop-blur-md border border-white/10 p-3 rounded-xl">
              <ShieldCheck className="text-primary size-8" />
              <div>
                <p className="text-white font-bold text-sm">Fully Insured</p>
                <p className="text-white/70 text-xs">Guaranteed Work</p>
              </div>
            </div>
          </div>

          {}
          

        </div>
      </div>
    </section>;
}